// extracted by mini-css-extract-plugin
export default {"PresentationViewer":"Q33Qr","loading":"vTple","Frame":"iNuc6","paddingLeft":"Y0_tJ","paddingRight":"rP6pQ","disablePointEvents":"S75NO","viewerHeader-docPages":"Nqz0x"};